/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents a file sitting in google cloud storage.
 * @export
 * @interface Asset
 */
export interface Asset {
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Asset
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof Asset
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    pipeUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    cdnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    originalContentType?: string;
    /**
     * 
     * @type {number}
     * @memberof Asset
     */
    size: number;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    owner?: string;
    /**
     * Hub this asset belongs to (set for hub-owner uploads)
     * @type {string}
     * @memberof Asset
     */
    surfaceId?: string;
}

/**
 * Check if a given object implements the Asset interface.
 */
export function instanceOfAsset(value: object): value is Asset {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('pipeUrl' in value) || value['pipeUrl'] === undefined) return false;
    if (!('cdnUrl' in value) || value['cdnUrl'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    return true;
}

export function AssetFromJSON(json: any): Asset {
    return AssetFromJSONTyped(json, false);
}

export function AssetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Asset {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'fileName': json['fileName'],
        'url': json['url'],
        'pipeUrl': json['pipeUrl'],
        'cdnUrl': json['cdnUrl'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'contentType': json['contentType'],
        'originalContentType': json['originalContentType'] == null ? undefined : json['originalContentType'],
        'size': json['size'],
        'owner': json['owner'] == null ? undefined : json['owner'],
        'surfaceId': json['surfaceId'] == null ? undefined : json['surfaceId'],
    };
}

export function AssetToJSON(json: any): Asset {
    return AssetToJSONTyped(json, false);
}

export function AssetToJSONTyped(value?: Asset | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'fileName': value['fileName'],
        'url': value['url'],
        'pipeUrl': value['pipeUrl'],
        'cdnUrl': value['cdnUrl'],
        'name': value['name'],
        'description': value['description'],
        'contentType': value['contentType'],
        'originalContentType': value['originalContentType'],
        'size': value['size'],
        'owner': value['owner'],
        'surfaceId': value['surfaceId'],
    };
}

